define('shared/remote/settings/student/put',[
    'shared/lib/RSVP',
    'shared/remote/ajax',
    'shared/remote/account/current'
], function(
    RSVP,
    ajax,
    getCurrentAccount
){

    return function(group, settings) {
        if (!group || !settings) {
            throw new Error('No enough arguments');
        }

        var data = {
            'settings': settings
        };

        return RSVP.resolve()
            .then(function(){
                return getCurrentAccount({
                    raw: true
                });
            })
            .then(function(accountInfo){
                return ajax({
                    method: 'put',
                    url: '/1/api/student-settings/v1/student/settings/' + group,
                    data: data,
                    headers: {
                        'X-EF-ACCESS': accountInfo.access
                    }
                });
            });
    };
});
